import { Component, OnInit } from '@angular/core';
import {PaymentRequestsBeneficiaries } from 'src/app/shared/models/paymentRequestsBeneficiaries';
import { Subscription } from 'rxjs';
import { NgForm, FormBuilder, FormGroup } from '@angular/forms';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { PaymentrequestsBeneficiariesService } from 'src/app/shared/services/paymentrequests-beneficiaries.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentrequestsService } from '../../../shared/services/paymentrequests.service';

@Component({
  selector: 'app-new-beneficiary',
  templateUrl: './new-beneficiary.component.html',
  styleUrls: ['./new-beneficiary.component.scss']
})
export class NewBeneficiaryComponent implements OnInit {
  subscriptions: Subscription[] = [];
  newBeneficiary: PaymentRequestsBeneficiaries;
  redirectsTo: string;
  bancos: any[];
  // newreq

  constructor( 
    private route: ActivatedRoute,
    private router: Router,
    private utilitiesService:UtilitiesService,
    private paymentrequestsBeneficiariesService: PaymentrequestsBeneficiariesService,
    private paymentrequestsService: PaymentrequestsService,
  ) { 
    if (this.route.snapshot.params['id']) {
      this.redirectsTo = '/dash/payment-requests/new';
    } else {
      this.redirectsTo = '/dash/';
    }
    let companyData = this.utilitiesService.getCompanyData();
    this.newBeneficiary = new PaymentRequestsBeneficiaries;
    this.newBeneficiary.companyId = companyData.id;
    this.newBeneficiary.companyName = companyData.companyName;
    // this.newBeneficiary.beneficiaryIsInc = true;
    this.newBeneficiary.dateCreated = utilitiesService.dateToNumber(new Date());  
  }

  ngOnInit() {
    this.paymentrequestsService.getBancos().subscribe(res =>{
      this.bancos = res.data;
    })
  }

  saveBeneficiary(data){
    if (data.validationGroup.validate().isValid) {
      this.paymentrequestsBeneficiariesService.newPaymentRequestsBeneficiaries(this.newBeneficiary).then(entry => {
        this.utilitiesService.notifyMe('Balance agregado al cliente', 'success');
        this.router.navigate([this.redirectsTo]);
      }).catch(error => console.log(error)
     );
   }
    // this.paymentrequestsBeneficiariesService.newPaymentRequestsBeneficiaries()
  }

}
